import Vuex from 'vuex';
import Router from 'vue-router';
import VueMoment from './plugins/vue-moment';
import numberOrdinal from './utils/numberOrdinal.js';
import twoDecimalPlaces from './utils/twoDecimalPlaces.js';
import capitalizeFirstLetter from './utils/capitalizeFirstLetter.js';
import useBrand from '@newsperform/core-component-lib/src/plugins/brand';
import useAnalytics from '@newsperform/core-component-lib/src/plugins/vue-analytics';
import VueLazyload from 'vue-lazyload';
import Analytics from 'vue-analytics';
import 'moment/locale/en-au';

import './themes/punters_theme.scss';

export default {
  install(Vue) {
    Vue.use(Vuex);
    Vue.use(Router);
    Vue.use(VueMoment);
    Vue.use(VueLazyload, {
      observer: true,
      lazyComponent: true,
    });
    useBrand(Vue, 'punters', true);
    useAnalytics(Vue);
    Vue.filter('numberOrdinal', numberOrdinal);
    Vue.filter('twoDecimalPlaces', twoDecimalPlaces);
    Vue.filter('capitalizeFirstLetter', capitalizeFirstLetter);
    Vue.component('BestOdds', () => import('./components/BestOdds/BestOdds.vue'));
    Vue.component('BettingPromotions', () => import('./components/BettingPromotions/BettingPromotions.vue'));
    Vue.component('BettingPromotionsList', () => import('./components/BettingPromotions/BettingPromotionsList.vue'));
    Vue.component('BookmakerStacker', () => import('./components/BookmakerStacker/BookmakerStacker.vue'));
    Vue.component('BottomMenu', () => import('./components/BottomMenu/BottomMenu.vue'));
    Vue.component('Countdown', () => import('./components/Countdown/Countdown.vue'));
    Vue.component('CountdownBanner', () => import('./components/CountdownBanner/CountdownBanner.vue'));
    Vue.component('FormFinder', () => import('./components/FormFinder/FormFinder.vue'));
    Vue.component('FormGuideEventCard', () => import('./components/FormGuideEventCard/FormGuideEventCard.vue'));
    Vue.component('FormGuideEventHeader', () => import('./components/FormGuideEventHeader/FormGuideEventHeader.vue'));
    Vue.component('FormGuideFullForm', () => import('./components/FormGuideFullForm/FormGuideFullForm.vue'));
    Vue.component('FormGuideMeetingHeader', () =>
      import('./components/FormGuideMeetingHeader/FormGuideMeetingHeader.vue')
    );
    Vue.component('PuntersFormGuideSpeedMap', () =>
      import('./components/PuntersFormGuideSpeedMap/PuntersFormGuideSpeedMap.vue')
    );
    Vue.component('FreeTipsAccordion', () => import('./components/FreeTipsAccordion/FreeTipsAccordion.vue'));
    Vue.component('GearChangesTabs', () => import('./components/GearChangesTabs/GearChangesTabs.vue'));
    Vue.component('GroupOneRaceTips', () => import('./components/GroupOneRaceTips/GroupOneRaceTips.vue'));
    Vue.component('NextToPlaySquare', () => import('./components/NextToPlay/NextToPlaySquare.vue'));
    Vue.component('Predictor', () => import('./components/Predictor/Predictor.vue'));
    Vue.component('PuntersEdge', () => import('./components/PuntersEdge/PuntersEdge.vue'));
    Vue.component('RacingOddsComparisonTable', () =>
      import('./components/RacingOddsComparisonTable/RacingOddsComparisonTable.vue')
    );
    Vue.component('SignPosts', () => import('./components/SignPosts/SignPosts.vue'));
    Vue.component('VideoTiles', () => import('./components/Video/VideoTiles.vue'));
    Vue.component('RacingButtonLinks', () => import('./components/RacingButtonLinks/RacingButtonLinks.vue'));
    Vue.component('SectionalHow', () => import('./components/SectionalHow/SectionalHow.vue'));
    Vue.component('HomePageFeatureTiles', () => import('./components/HomePageFeatureTiles/HomePageFeatureTiles.vue'));
    Vue.component('LiteRegistration', () =>
      import('@newsperform/core-component-lib/src/components/LiteRegistration/LiteRegistration.vue')
    );
  },
  Analytics,
};
